export type DebugEligibilityInput = {
  dev: boolean
  vercelEnv?: string
  sessionStatus: 'loading' | 'authenticated' | 'unauthenticated'
  email?: string | null | undefined
}

export function isStaffEmail(email?: string | null): boolean {
  if (!email || typeof email !== 'string') return false
  return email.trim().toLowerCase().endsWith('@tootz.com.br')
}

export function isDebugPanelEligible(input: DebugEligibilityInput): boolean {
  if (input.dev) return true
  if (input.vercelEnv === 'preview') return true
  if (
    input.sessionStatus === 'authenticated' &&
    isStaffEmail(input.email)
  ) {
    return true
  }
  return false
}
